import React from "react";
import { Gem, Palette, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const coreValues = [{
  id: 1,
  title: "Black Tie",
  description: "We invite you to join us in your finest formal attire. Think floor-length gowns and classic tuxedos for an evening of timeless sophistication.",
  iconName: "Gem"
}, {
  id: 2,
  title: "Color Palette",
  description: "To complement our aesthetic, we suggest tones of champagne, espresso, and blush. Small swatches below help you coordinate with our vision.",
  iconName: "Palette"
}, {
  id: 3,
  title: "Guest\nArrival",
  description: "Please arrive twenty minutes early to enjoy the garden views. Valet service will be available at the main entrance for all our guests.",
  iconName: "Clock"
}];
export default function OurPrinciplesAndValues() {
  const renderIcon = (name: string) => {
    switch (name) {
      case "Gem":
        return <Gem className="w-8 h-8 text-primary" />;
      case "Palette":
        return <Palette className="w-8 h-8 text-primary" />;
      case "Clock":
        return <Clock className="w-8 h-8 text-primary" />;
      default:
        return null;
    }
  };
  return <section data-section-id="224438" id="attire-guidance" className="bg-background py-24 text-foreground" dir="ltr">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-light tracking-tight text-foreground italic">
            Attire & Guidance
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-20">
          {coreValues.map((value, i) => <div data-index={i} key={value.id} className="flex">
              <Card className="w-full border-none transition-all duration-500 bg-card shadow-md hover:shadow-xl flex flex-col items-center text-center pt-8 pb-4 px-4 rounded-lg">
                <CardHeader className="pb-4 flex flex-col items-center">
                  <div className="w-16 h-16 rounded-lg bg-accent/50 flex items-center justify-center mb-6">
                    {renderIcon(value.iconName)}
                  </div>
                  <CardTitle className="font-default text-2xl font-medium tracking-wide text-foreground">
                    {value.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-sm text-foreground/80 leading-relaxed tracking-wider">
                    {value.description}
                  </p>
                  {value.id === 2}
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}